import { render, staticRenderFns } from "./ProjectListMenu.vue?vue&type=template&id=b6ca2af6&scoped=true&"
import script from "./ProjectListMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectListMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListMenu.vue?vue&type=style&index=0&id=b6ca2af6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ca2af6",
  null
  
)

export default component.exports